import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import * as fromExpertise from '../../core/reducers/expertise.reducer';
import * as actionExpertise from '../../core/actions/expertise.actions';
import { delay } from 'rxjs/operators';

@Component({
    selector: 'app-expertise',
    templateUrl: './expertise.component.html',
    styleUrls: ['./expertise.component.scss']
})
export class ExpertiseComponent implements OnInit {
    navLinks = [
  	    { 
  		    label: 'Liste' ,
  		    path: 'lists',  		
  	    },
    ];

    public constructor(
        private store: Store<any>
    ) {
    }

    ngOnInit() {
        this.store.select(fromExpertise.selectOpenExpertises).pipe(delay(500)).subscribe(state => {
            this.navLinks = [
                { 
                    label: 'Liste' ,
                    path: 'list',      
                }
            ];

            this.navLinks = this.navLinks.concat(state.map(e => {
                return {
                    'label': e.name,
                    'path': 'view/' + e.id,
                    'id': e.id,
                    canBeDeleted: true
                };
            }));        
        })
    }

    deleteTab(idx) {
        this.store.dispatch(new actionExpertise.CloseTabAction(idx));
    }

}
